export var DropdownToggleType;
(function (DropdownToggleType) {
    DropdownToggleType["buttonIcon"] = "buttonIcon";
    DropdownToggleType["button"] = "button";
    DropdownToggleType["buttonAvatar"] = "buttonAvatar";
})(DropdownToggleType || (DropdownToggleType = {}));
//# sourceMappingURL=index.js.map